export default {
  process: {
    title: 'ประมวลผล Time',
    settingsTitle: 'ข้อมูลการประมวลผล',
    employeesTitle: 'พนักงานและรอบประมวลผล',
    company: 'บริษัท',
    type: 'ประเภทการประมวลผล',
    daily: 'I/O + ค่าตอบแทนรายวัน',
    monthly: 'ค่าตอบแทนรายเดือน',
    employees: 'รหัสพนักงาน',
    employeesHelp: 'แยกบรรทัดหรือคั่นด้วย comma ต้องมีพนักงานอย่างน้อยหนึ่งคน',
    date: 'วันที่ทำงาน',
    currentPeriod: 'รายเดือนใช้ Pay period ปัจจุบันของบริษัทที่เลือก',
    review: 'ตรวจสอบและยืนยัน',
    invalid: 'กรอกรหัสพนักงาน และวันที่ทำงานที่ถูกต้องสำหรับ I/O + รายวัน',
    processing: 'กำลังประมวลผล โปรดรอและอย่าส่งซ้ำ',
    latest: 'ผลล่าสุด',
    confirmation: 'ยืนยันการประมวลผล',
    employeeCount: 'พนักงาน ({{count}} คน)',
    confirmNote:
      'การทำงานนี้อาจอัปเดตข้อมูล I/O และค่าตอบแทนเดิม การรับคิว OT ไม่ได้หมายความว่าคำนวณ OT เสร็จแล้ว',
    cancel: 'ยกเลิก',
    confirm: 'ยืนยันประมวลผล',
    status: {
      completed: 'เสร็จสิ้น',
      partial: 'สำเร็จบางส่วน',
      'no-data': 'ไม่มีข้อมูล',
      rejected: 'คำขอถูกปฏิเสธ',
      unknown: 'ไม่ทราบผลสุดท้าย'
    },
    dailyCompleted:
      'ประมวลผล I/O และค่าตอบแทนรายวันแล้ว ส่งคิว OT แล้วแต่ยังไม่ยืนยันว่า OT เสร็จ',
    monthlyCompleted: 'ประมวลผลค่าตอบแทนรายเดือนแล้ว',
    monthlyNoData: 'ไม่มีรายการค่าตอบแทนรายเดือนที่ผ่านเกณฑ์',
    dailyNoData: 'ไม่มี I/O ที่ผ่านกติกาประมวลผลเดิม',
    noSource: 'ไม่พบคำขอ Time หรือข้อมูลดิบ/store ของพนักงานและวันที่เลือก',
    queueFailed:
      'บันทึก I/O และค่าตอบแทนรายวันแล้ว แต่ส่งคิว OT ไม่สำเร็จ โปรดตรวจข้อมูลและ log ก่อนสั่งใหม่',
    rowErrors:
      'บางแถวไม่สามารถสร้าง I/O ได้ โปรดตรวจข้อมูลที่บันทึกก่อนสั่งใหม่',
    employeeMismatch: 'พนักงานทุกรหัสต้องอยู่ในบริษัทที่เลือก',
    employeeAmbiguous:
      'พบรหัสพนักงานเดียวกันในหลายบริษัท ระบบปฏิเสธก่อนประมวลผล เพราะ lookup กะปัจจุบันยังแยกบริษัทไม่ได้',
    periodMissing: 'ไม่พบ Pay period ของบริษัทที่ครอบคลุมวันที่นี้',
    rejectedMessage:
      'คำขอถูกปฏิเสธ โปรดตรวจสิทธิ์ พนักงาน บริษัท และ Pay period',
    unknownMessage:
      'ไม่ทราบผลสุดท้าย อาจมีการบันทึกข้อมูลแล้ว โปรดตรวจข้อมูลและ log ก่อนสั่งใหม่ ระบบไม่ส่งซ้ำอัตโนมัติ'
  },
  title: 'บริหารเวลาออนไลน์',
  home: 'หน้าหลัก',
  tabs: {
    process: 'ประมวลผล',
    time: 'บริหารเวลา',
    'special-allowance': 'เงินได้พิเศษ',
    import: 'นำเข้าข้อมูล',
    export: 'ส่งออกข้อมูล'
  },
  'table-branch': {
    title: 'ตั้งค่าสาขา E-Time',
    description: 'จัดการการตั้งค่า E-Time ของแต่ละสาขา',
    company: 'บริษัท {{company}}',
    branches: 'รายการสาขา',
    action: 'จัดการ',
    'edit-settings': 'แก้ไขการตั้งค่า',
    'add-button': 'เพิ่มสาขา',
    id: 'ลำดับที่',
    branchCode: 'รหัสสาขา',
    describe: 'รายละเอียดเพิ่มเติม'
  },
  'main-setting': {
    modal: {
      add: 'เพิ่มเงื่อนไข {{type}}',
      edit: 'แก้ไขเงื่อนไข {{type}}',
      'ot-permission': 'อนุญาตให้ผู้อนุมัติแก้ไขเวลา OT'
    },
    'branch-information': 'ข้อมูลสาขา',
    'add-title': 'เพิ่มการตั้งค่าสาขา E-Time',
    'company-code': 'รหัสบริษัท',
    'branch-code': 'รหัสสาขา',
    'branch-help':
      'ใช้รหัสตรงกับสาขาในระบบพนักงาน เช่น BANGKOK การบันทึกนี้เพิ่มเฉพาะการตั้งค่า E-Time ไม่ได้สร้างสาขาในระบบพนักงาน',
    'main-workflow': 'สายการอนุมัติหลัก',
    'main-workflow-help':
      'ใช้กับรายการที่ไม่ตรงกับเงื่อนไขฝ่ายหรือแผนกที่ระบุด้านล่าง',
    'add-condition': 'เพิ่มเงื่อนไขฝ่ายหรือแผนก',
    'condition-required':
      'เลือกฝ่ายหรือแผนกอย่างน้อยหนึ่งอย่าง และเลือกสายการอนุมัติ',
    'condition-duplicate': 'มีเงื่อนไขฝ่ายและแผนกชุดนี้แล้ว',
    required: 'กรุณาระบุข้อมูลนี้',
    duplicate: 'มีการตั้งค่ารหัสสาขานี้ในบริษัทแล้ว',
    'save-error': 'บันทึกไม่สำเร็จ กรุณาตรวจสอบข้อมูลและลองอีกครั้ง',
    'access-denied': 'คุณไม่มีสิทธิ์เพิ่มการตั้งค่าสาขา E-Time',
    'edit-title': 'แก้ไขตั้งค่าบริหารเวลา',
    'sub-title': { ot: 'ตั้งค่าโอที', time: 'ตั้งค่าเวลา' },
    form: {
      enableCardMapping: 'การจับคู่พนักงานกับบัตรพนักงาน',
      enableAppEditTime: 'อนุญาติผู้อนุมัติแก้ไขเวลา',
      division: 'ฝ่าย',
      department: 'แผนก',
      workflowCode: 'รหัสสายอนุมัติ'
    }
  },
  form: {
    'sp-allowance': {
      'add-title': 'เพิ่มเงินได้พิเศษ',
      'edit-title': 'แก้ไขเงินได้พิเศษ',
      description: 'กำหนดข้อมูลเงินได้พิเศษ ช่วงค่า และสายการอนุมัติ',
      information: 'ข้อมูลเงินได้พิเศษ',
      approval: 'ศูนย์ต้นทุนและสายอนุมัติ',
      code: { label: 'รหัสเงินได้พิเศษ' },
      name: { label: 'ชื่อเงินได้พิเศษ' },
      minCost: { label: 'ค่าต่ำสุด' },
      maxCost: { label: 'ค่าสูงสุด' },
      costCenterCode: { label: 'ศูนย์ต้นทุน' },
      workflowCode: { label: 'สายการอนุมัติ' }
    }
  },
  'table-special-allowance': {
    title: 'เงินได้พิเศษ',
    description: 'จัดการรหัสเงินได้พิเศษ พร้อมกำหนดค่าต่ำสุดและค่าสูงสุด',
    company: 'บริษัท {{code}}',
    'list-title': 'รายการเงินได้พิเศษ',
    edit: 'แก้ไขเงินได้พิเศษ',
    delete: 'ลบเงินได้พิเศษ',
    id: 'id',
    code: 'Allowance code',
    name: 'Allowance name',
    costCenterName: 'Cost center name',
    'add-button': 'เพิ่มเงินได้พิเศษ',
    min: 'ค่าต่ำสุด',
    max: 'ค่าสูงสุด',
    action: 'การกระทำ'
  }
}
